import {requests} from "../../helpers/api.services";
import {TEMPLATE_SETTINGS_URL} from "../../helpers/api.routes";
import {ITemplateSettings} from "./index";

export const AdminTemplateSettingsService = {
    get: () => requests.get(TEMPLATE_SETTINGS_URL),
    create: (params: ITemplateSettings) => requests.post(TEMPLATE_SETTINGS_URL, params)
}